// extracted by mini-css-extract-plugin
module.exports = {"create__user_modal_body":"tableList_create__user_modal_body__18JAz"};